import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import * as color from '../../config/colors';
import * as background from '../../config/backgroundColor';
import * as series from '../../config/series';
import * as tooltip from '../../config/tootip';
import * as xAxis from '../../config/xAxis';
import * as yAxis from '../../config/yAxis';
import * as grid from '../../config/grid';
import * as legend from '../../config/legend';
import { CommonService } from '../../service/common.service';
import { EChartOption } from 'echarts';
import { clone, cloneDeep, isNil } from 'lodash';
import { ChartOptionService } from '../../service/chart-option.service';
import { ECharts } from 'echarts';
import { CompareChartComponent } from './compare-chart.component';


@Injectable({
  providedIn: 'root'
})
export class CompareChartService {

  constructor(
    private commonService: CommonService,
    private chartOptionService: ChartOptionService
  ) { }

  // 获取x轴
  getChartxAxis() {
    let xAxisOption: EChartOption.XAxis[] = this.chartOptionService.getChartxAxis(1);
    xAxisOption.forEach(e => {
      e['boundaryGap'] = true;
      e['axisTick']['show'] = false;
      e['axisTick']['alignWithLabel'] = true;
    })
    return xAxisOption;
  }

  getChartyAxis(num: number) {
    let yAxisOption: EChartOption.YAxis[] = this.chartOptionService.getChartyAxis(1);
    yAxisOption.forEach(e => {
      e['minInterval'] = 5;
    })
    return yAxisOption;
  }

  setXaxisName(xAxisOption: EChartOption.XAxis[], name: string) {
    xAxisOption.forEach(e => {
      e.name = name;
    })
  }

  setYaxisName(yAxisOption: EChartOption.YAxis[], name: string) {
    yAxisOption.forEach(e => {
      e.name = name;
    })
  }

  setYnameGap(yAxisOption: EChartOption.YAxis[], yNameGap: number) {
    yAxisOption.forEach(e => {
      e.nameGap = yNameGap;
    })
  }

  topLegendChange(legendData: any[], echartInstance: ECharts) {
    legendData.forEach(e => {
      if (e.checked) {
        echartInstance.dispatchAction({
          type: "legendSelect",
          name: e.value
        });
      } else {
        echartInstance.dispatchAction({
          type: "legendUnSelect",
          name: e.value
        });
      }
    });
  }

  setSmallModeGrid(gridOption: EChartOption.Grid) {
    gridOption.top = grid.baseSmallPadding;
    gridOption.bottom = grid.baseSmallPadding;
    gridOption.left = grid.baseSmallPadding;
    gridOption.right = grid.baseSmallPadding;
  }

  setSmallModePadding(component) {
    component.cardPadding = "0rem";
  }

  setLegendPosition(gridOption: EChartOption.Grid, legendOption, legendPosition) {
    let style = this.commonService.changeFontSize();
    switch (legendPosition) {
      case "top":
        legendOption.show = false;
        gridOption.bottom = style.noLegendGrid.bottom;
        break;
      case "right":
        // gridOption.right = legend.rightLegendWidth;
        gridOption.top = style.rightLegendGrid.top;
        gridOption.bottom = style.rightLegendGrid.bottom;
        gridOption.left = style.rightLegendGrid.left;
        gridOption.right = style.rightLegendGrid.right;

        legendOption['top'] = '14%';
        legendOption['bottom'] = '12%';
        legendOption['right'] = 0;
        legendOption['width'] = 100;
        legendOption['orient'] = "vertical";
        legendOption['pageIcons'] = {
          vertival: [
            "path://M472.064 272.448l-399.232 399.232c-22.08 22.08-22.08 57.792 0 79.872 22.016 22.016 57.792 22.08 79.872 0L512 392.256l359.296 359.296c22.016 22.016 57.792 22.08 79.872 0 22.08-22.08 22.016-57.792 0-79.872L551.936 272.448C529.856 250.432 494.144 250.432 472.064 272.448z",
            "path://M472.064 751.552 72.832 352.32c-22.08-22.08-22.08-57.792 0-79.872 22.016-22.016 57.792-22.08 79.872 0L512 631.744l359.296-359.296c22.016-22.016 57.792-22.08 79.872 0 22.08 22.08 22.016 57.792 0 79.872l-399.232 399.232C529.856 773.568 494.144 773.568 472.064 751.552z"
          ],
        };
        legendOption['textStyle']['padding'] = [2, 0, 0, 0];
        break;
      case "none":
        legendOption.show = false;
        gridOption.bottom = style.noLegendGrid.bottom;
        break;
      default:
        gridOption.bottom = legend.bottomLegendHeight;
        break;
    }
  }

  setInterval(echartOption, interval: Number) {
    echartOption.xAxis[0].axisLabel.interval = interval;
  }

  buildSeries(chartData: any, seriesList: EChartOption.Series[], xAxisOption: EChartOption.XAxis[], yAxisOption: EChartOption.YAxis[], lineSeriesOption: EChartOption.Series, customSeriesOption: EChartOption.Series) {
    seriesList.length = 0;
    if (!_.isNil(chartData) && chartData.hasOwnProperty('lineData')) {
      let lineSeries: EChartOption.Series = cloneDeep(lineSeriesOption);

      lineSeries['data'] = chartData.lineData;
      lineSeries['name'] = chartData.seriesName
      lineSeries['smooth'] = false;
      lineSeries['symbol'] = 'none';
      lineSeries['itemStyle'] = {};
      lineSeries['itemStyle']['color'] = '#77bef7'
      seriesList.push(lineSeries);
    }
    if (!_.isNil(chartData) && chartData.hasOwnProperty('rectData')) {
      // customSeriesOption.data = chartData.reactData;
      let max = this.getMaxAndMin(chartData.rectData)[1],
        min = this.getMaxAndMin(chartData.rectData)[0];

      min = isFinite(min) ? min : 0;
      max = isFinite(max) ? max : 0;
      let yMinTick = min - (min % 5);
      let yMaxTick = max + (5 - (max % 5));

      // 修改y轴刻度
      yAxisOption.forEach(element => {
        element.min = yMinTick;
        element.max = yMaxTick;
      })


      let customSeries: EChartOption.SeriesCustom = this.chartOptionService.getCompareCustomSeries();
      let compareData = chartData.rectData.map((item) => {
        let color = '';
        color = item[2] < 0 ? '#43ac34' : '#cc1313';
        return {
          value: item, itemStyle: {
            color: color,
            borderColor: '#000',
            borderWidth: 1
          }
        }
      })


      customSeries.data = compareData;
      customSeries['name'] = chartData.seriesName;
      seriesList.push(customSeries)
    }

    if (!_.isNil(chartData) && chartData.hasOwnProperty('xData')) {
      xAxisOption.forEach(e => {
        e.data = chartData.xData
      })
    }

  }

  /* 
    darkMode
  */
  changeChartTitleDark(component: CompareChartComponent, darkMode: boolean) {
    if (darkMode) {
      component.chartTitleColor = color.darkModeTextColor;
      component.cardBgColor = background.darkModeBGColor;
    }
  }

  xAxisDarkMode(xAxisOption: EChartOption.XAxis[]) {
    xAxisOption.forEach(e => {
      if (isNil(e['axisLabel'])) {
        e['axisLabel'] = {};
      }
      e['axisLabel']['color'] = color.darkModeTextColor;
      if (isNil(e['nameTextStyle'])) {
        e['nameTextStyle'] = {};
      }
      e['nameTextStyle']['color'] = color.darkModeTextColor;
    });
  }

  yAxisDarkMode(yAxisOption: EChartOption.YAxis[]) {
    yAxisOption.forEach(e => {
      if (isNil(e['axisLabel'])) {
        e['axisLabel'] = {};
      }
      e['axisLabel']['color'] = color.darkModeTextColor;
      if (isNil(e['nameTextStyle'])) {
        e['nameTextStyle'] = {};
      }
      e['nameTextStyle']['color'] = color.darkModeTextColor;
      if (isNil(e['splitLine'])) {
        e['splitLine'] = {
          lineStyle: {
            color: color.darkModeTextColor
          }
        };
      } else {
        if (isNil(e['splitLine']['lineStyle'])) {
          e['splitLine']['lineStyle'] = {
            color: color.darkModeTextColor
          }
        } else {
          e['splitLine']['lineStyle']['color'] = color.darkModeTextColor;
        }
      }
    });
  }

  colorsDarkMode(colors: string[]) {
    colors.length = 0;
    color.darkModeColors.forEach(e => {
      colors.push(e);
    })
  }

  chartBackgroundColorDarkMode(chartOption) {
    chartOption.backgroundColor = background.darkModeBGColor;
  }

  legendDarkMode(legendOption) {
    if (isNil(legendOption['textStyle'])) {
      legendOption['textStyle'] = {
        color: color.darkModeTextColor
      };
    } else {
      legendOption['textStyle']['color'] = color.darkModeTextColor;
    }
  }

  seriesDarkMode(lineSeriesOption: EChartOption.Series, customSeriesOption: EChartOption.Series) {
    if (isNil(lineSeriesOption['label'])) {
      lineSeriesOption['label'] = {};
    }
    // if (isNil(customSeriesOption['itemStyle'])) {
    //   customSeriesOption['itemStyle'] = {}
    // }

    // customSeriesOption['itemStyle']['borderColor'] = color.darkTextColor;
    lineSeriesOption['label']['color'] = color.darkModeTextColor;
  }

  //获取最大值和最小值
  getMaxAndMin(rectData) {
    let tempArr = [], min = 0, max = 0;
    rectData.forEach(element => {
      tempArr.push(element[1], element[3])
    });
    min = Math.min.apply(null, tempArr.filter(item => item !== '--'));
    max = Math.max.apply(null, tempArr.filter(item => item !== '--'));
    return [min, max]
  }

  setTooltipUnit(tooltipOption: EChartOption.Tooltip, unit: string, years: string[]) {
    tooltipOption.formatter = this.chartOptionService.getCompareCustomTooltip(unit, years).formatter;
  }

  // 设置x轴label旋转
  setXaxisLabelRotate(xAxisOption: EChartOption.XAxis[], rotate) {
    let angle = 0;
    switch (rotate) {
      case 'leftSmallAngle':
        angle = 30
        break;
      case 'leftBigAngle':
        angle = 60
        break;
      case 'rightSmallAngle':
        angle = -30
        break;
      case 'rightBigAngle':
        angle = -60
        break
    }
    xAxisOption.forEach(e => {
      e.axisLabel.rotate = angle
    })
  }

  setYAxisMin(yAxisOption: EChartOption.YAxis[], yAxisMin: number) {
    yAxisOption.forEach(e => {
      e.min = yAxisMin;
    })
  }

  setYAxisMax(yAxisOption: EChartOption.YAxis[], yAxisMax: number) {
    yAxisOption.forEach(e => {
      e.max = yAxisMax;
    })
  }

  setYAxisInterval(yAxisOption: EChartOption.YAxis[], yAxisInterval: number) {
    yAxisOption.forEach(e => {
      e.interval = yAxisInterval;
    })
  }

  setYAxisSplitLine(yAxisOption: EChartOption.YAxis[], splitLineShow: boolean) {
    yAxisOption.forEach(e => {
      e.splitLine.show = splitLineShow;
    })
  }

}
